export const data = [
  {
    stars: 5,
    avatar: "/assets/recommend/9.png",
    name: "Richard Conn",
    position: "CTO",
    description: `Hussain is really a great problem solver, I've impressed by his ability to solve complicated technical problems with the minimum amount of management, he is really super learner and an effective implementor, write your requirements and he will make sure it gets done, that's the ultimate factor in the reliable developers, Hussain is basically one of them and I highly recommend him in any full-stack development job.`,
  },
  {
    stars: 5,
    avatar: "/assets/recommend/5.png",
    name: "Pablo Kevin",
    position: "Full Stack Developer",
    description: `Working with Hussain was an absolute delight. Their exceptional speed and skill allowed us to transform our company's landing page vision into reality within just one week. What truly stood out was the prompt and clear communication throughout the project. The quality of their work is undeniably top-notch, and the results exceeded our expectations. You won't be disappointed: That's for sure`,
  },
  {
    stars: 5,
    avatar: "/assets/recommend/3.png",
    name: "John Sanders",
    position: "CEO",
    description: `We worked with Hussain to revamp our website's frontend. He did an amazing job and was enthusiastic the entire time. He would always recommend stuff and made sure that he understood our design intention to get the best output.On top of his great skills and work ethic, Hussain is a very honest man and has a great attitude. I would recommend him to anyone looking for web developer.`,
  },
];
